<template>
    <div
      v-if="!isTableReady"
      class="d-flex justify-content-center align-items-center m-5"
    >
      <div
        class="spinner-border text-dark"
        style="width: 7.5rem; height: 7.5rem"
        role="status"
      >
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="container-fluid container-wrapper" v-else>
        <v-card flat class="card border-0 shadow table-wrapper-tsoc">
          <v-col cols="12">
            <v-row>
              <v-col cols="12">
                <v-card-item class="sticky">
                  <v-card-title>Client Overrun (EUR) By Month</v-card-title>
                </v-card-item>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-card-text>
                <v-data-table-virtual
                  :headers="header"
                  :items="contractsOverrun"
                  :search="searchQuery"
                  fixed-header=""
                  :loading="tableDataReady"
                >
                  <template #bottom></template>
                </v-data-table-virtual>
              </v-card-text>
            </v-row>
          </v-col>
        </v-card>
      </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { storeToRefs } from "pinia";
import { useClientStore } from "../stores/client"

const clientStore = useClientStore()

const {
    contractsOverrun
} = storeToRefs(clientStore)

const {
    fetchContractsOverrun
} = clientStore

const isTableReady = ref(false);

onMounted(async () => {
    await fetchContractsOverrun()
    contractsOverrun.value.sort((a, b) => {
        const dateA = new Date(a.ReportDate)
        const dateB = new Date(b.ReportDate)
        return dateB - dateA
    })
    isTableReady.value = true
})

const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const header = [
    {title: "Report Date", key: "ReportDate", align:"start", sortable: true},
    {title: "CS Time", key:"ECOCSMTime", value: (item) => {
        return item.ECOCSMTime > 0 ? `${numberWithCommas(item.ECOCSMTime.toFixed(2))}` : "-"
    }},
    {title: "PS Time", key:"ECOPSTime", value: (item) => {
        return item.ECOPSTime > 0 ? `${numberWithCommas(item.ECOPSTime.toFixed(2))}` : "-"
    }},
    {title: "MUV Resource Usage", key:"ECOMUVResourceUsage", value: (item) => {
        return item.ECOMUVResourceUsage > 0 ? `${numberWithCommas(item.ECOMUVResourceUsage.toFixed(2))}` : "-"
    }},
    {title: "Total", key:"ECOTotal", value: (item) => {
        return item.ECOTotal > 0 ? `${numberWithCommas(item.ECOTotal.toFixed(2))}` : "-"
    }},
    {title: "Total Annualised Cost Overrun", key:"TotalAnnualisedCostOverrun", value: (item) => {
        return item.TotalAnnualisedCostOverrun > 0 ? `${numberWithCommas(item.TotalAnnualisedCostOverrun.toFixed(2))}` : "-"
    }}
]

</script>

<style lang="scss">
.container-wrapper{
  height: 75vh;
  width: 110vw;
  overflow-y: auto;
}
.table-wrapper-tsoc {
  max-height: 70vh;
  width: 97vw;
  overflow-y: auto;
}

.table-scroll {
  overflow-y: scroll;
  max-height: max-content;
  width: 100%;
}
</style>